import { css } from 'styled-components';
import { BaseButtonProps } from 'types';
import { buttonBorderRadiusBySizeDecorator } from 'utils';
import { regular } from './regular';

export const round = ({ background, ...rest }: BaseButtonProps) => css`
	${regular(rest)}
	${buttonBorderRadiusBySizeDecorator(rest)}
`;
